import styled from 'styled-components';
import { Typography } from 'components/generic/typography';
import Icon from 'components/Icon';
import Tooltip from 'components/shared/Tooltip/Tooltip';
import ThemeProvider from 'theming/ThemeProvider';

interface IDisclaimer {
    disclaimer: string;
}

const IconContainer = styled.span`
`;

const StyledBody = styled(Typography.Body)`
    color: ${({ theme }) => theme.ColorTextPrimary};
`;

const StyledIcon = styled(Icon)`
    display: block;
    pointer-events: all;
    fill: currentColor;
`;

function TooltipContent({ disclaimer }: IDisclaimer) {
    return (
        <ThemeProvider theme="default">
            <StyledBody size="S">{disclaimer}</StyledBody>
        </ThemeProvider>
    );
}

export default function Disclaimer({ disclaimer }: IDisclaimer): JSX.Element {
    return (
        <Tooltip type="secondary" contentRenderer={() => <TooltipContent disclaimer={disclaimer} />}>
            {(props) => (
                <IconContainer {...props}>
                    <StyledIcon type="Information" size={16} aria-hidden />
                </IconContainer>
            )}
        </Tooltip>
    );
}
